import { StandardEvents } from '@shopify/events';

/**
 * Whop conversion events (Theme settings → Tracking), sent through the Whop pixel snippet.
 *
 * add_to_cart: every successful add to cart by the shopper. All of them go through the theme's standard
 * cart event: the product page buy button, quick add, the bundle builder, the pack colour picker and the
 * cart drawer's suggestions. The free gift is added automatically with action "update", so it isn't counted.
 * The value is the added items' price times quantity, in the shopper's currency.
 */

/** @param {string} prefix */
function eventId(prefix) {
  return `${prefix}-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/** @param {string | number} id - A variant id, or its gid://shopify/ProductVariant/… form */
function variantNumber(id) {
  return String(id).split('/').pop();
}

document.addEventListener(StandardEvents.cartLinesUpdate, (event) => {
  if (event.action !== 'add') return;
  const lines = Array.isArray(event.lines) ? event.lines : [];

  event.promise
    ?.then((result) => {
      const detail = result?.detail;
      if (detail?.didError) return;

      const items = Array.isArray(detail?.items) ? detail.items : [];
      let cents = 0;
      for (const line of lines) {
        const id = variantNumber(line.merchandiseId ?? line.id ?? '');
        const item = items.find((cartItem) => String(cartItem.variant_id) === id);
        if (item) cents += Number(item.price || 0) * Number(line.quantity || 1);
      }

      const currency = /** @type {any} */ (window).Shopify?.currency?.active || 'NOK';
      const args = ['add_to_cart', { value: cents / 100, currency, event_id: eventId('atc') }];

      // Whop runs only after the page has loaded and the visitor allows marketing (snippets/whop-pixel.liquid);
      // until then the event waits in holdraWhopPending, and without consent it is never sent
      const whop = /** @type {any} */ (window).whop;
      const pending = /** @type {any} */ (window).holdraWhopPending;
      if (typeof whop?.track === 'function') whop.track(...args);
      else if (Array.isArray(pending)) pending.push(args);
    })
    .catch(() => {});
});
